import dayjs from "dayjs";
import type { ColumnWithFilter } from "../../Components/FilterBar/FilterBar";
import type { LookupTableOption } from "../../Components/DataEntry/Select/LookupTableSelect";
import {
  formatLookupCurrency,
  getLookupTableText,
} from "./helpers";

export const buildBusinessPlanLookupOption = (businessPlan: any) => ({
  ...businessPlan,
  label: businessPlan?.code,
  value: businessPlan?._id,
  title: JSON.stringify({
    receiptAddress: businessPlan?.receiptAddress,
    deliveryAddress: businessPlan?.deliveryAddress,
    direction: businessPlan?.routeBase?.direction ?? businessPlan?.direction,
  }),
  raw: businessPlan,
});

const businessPlanTableColumns: ColumnWithFilter<LookupTableOption>[] = [
  {
    title: "Mã PAKD",
    dataIndex: "code",
    filterDataIndex: "searchText",
    filterConfig: {
      type: "string",
      filterProps: {
        placeholder: "Nhập mã PAKD",
      },
    },
    width: 130,
    render: (_value, record) => getLookupTableText(record, "code"),
  },
  {
    title: "Khách hàng",
    dataIndex: "customerName",
    filterConfig: {
      type: "string",
      filterProps: {
        placeholder: "Nhập khách hàng",
      },
    },
    width: 180,
    render: (_value, record) => getLookupTableText(record, "customerName"),
  },
  {
    title: "Mã tuyến",
    dataIndex: "routeBaseCode",
    filterConfig: {
      type: "string",
      filterProps: {
        placeholder: "Nhập mã tuyến",
      },
    },
    width: 130,
    render: (_value, record) => getLookupTableText(record, "routeBaseCode"),
  },
  {
    title: "Hình thức sở hữu",
    dataIndex: "ownership",
    filterConfig: {
      type: "select",
      filterProps: {
        placeholder: "Chọn hình thức sở hữu",
        options: [
          { label: "ĐẦU TƯ", value: "INVESTMENT" },
          { label: "THUÊ KHÔ", value: "DRY_RENTAL" },
          { label: "DỊCH VỤ", value: "SERVICE" },
        ],
      },
    },
    width: 150,
    render: (_value, record) => getLookupTableText(record, "ownership"),
  },
  {
    title: "Ngày",
    dataIndex: "validFrom",
    filterConfig: {
      type: "dateRange",
      filterProps: {},
    },
    width: 120,
    render: (_value, record) => {
      const validFrom = getLookupTableText(record, "validFrom");
      return validFrom ? dayjs(validFrom).format("DD/MM/YYYY") : "";
    },
  },
  {
    title: "Phân loại",
    dataIndex: "roadType",
    filterConfig: {
      type: "string",
      filterProps: {
        placeholder: "Nhập phân loại",
      },
    },
    width: 120,
    render: (_value, record) => getLookupTableText(record, "roadType"),
  },
  {
    title: "Chiều hàng",
    dataIndex: "direction",
    filterConfig: {
      type: "string",
      filterProps: {
        placeholder: "Nhập chiều hàng",
      },
    },
    width: 120,
    render: (_value, record) =>
      getLookupTableText(record, "direction") ||
      getLookupTableText(record, ["routeBase", "direction"]),
  },
  {
    title: "Điểm nhận",
    dataIndex: "receiptAddress",
    filterDataIndex: "receipt",
    filterConfig: {
      type: "string",
      filterProps: {
        placeholder: "Nhập điểm nhận",
      },
    },
    width: 220,
    render: (_value, record) => getLookupTableText(record, "receiptAddress"),
  },
  {
    title: "Điểm trả",
    dataIndex: "deliveryAddress",
    filterDataIndex: "delivery",
    filterConfig: {
      type: "string",
      filterProps: {
        placeholder: "Nhập điểm trả",
      },
    },
    width: 220,
    render: (_value, record) => getLookupTableText(record, "deliveryAddress"),
  },
  {
    title: "Doanh thu",
    dataIndex: "revenue",
    width: 140,
    render: (_value, record) =>
      formatLookupCurrency(getLookupTableText(record, "revenue")),
  },
];

export const businessPlanLookupTable = {
  popupWidth: 1240,
  searchPlaceholder: "Tìm theo mã PAKD",
  tableColumns: businessPlanTableColumns,
};
